import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';

var CostStatement = function (_super) {
  __extends(CostStatement, _super);

  function CostStatement() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.costStatementSearchEnum = [];
    _this.flowTypeList = [];
    _this.businessTypeList = [];
    _this.orderTypeList = [{
      value: 1,
      text: _this.t('FBA订单')
    }, {
      value: 2,
      text: _this.t('标准订单')
    }, {
      value: 3,
      text: _this.t('自提订单')
    }, {
      value: 4,
      text: _this.t('销毁订单')
    }];
    _this.chargeTypeList = [];
    _this.dataList = [];
    _this.loadingStatus = false;
    _this.esPoint = null;
    _this.columns = [];
    _this.rowSelection = {};
    _this.accountList = [];
    _this.selectedList = [];
    _this.selectedPendingConfirmList = [];
    _this.datetimeDefaultValue = _this.$util.getDefaultTimeCondition(31);
    _this.currencyList = [];
    _this.costTypeList = [];
    _this.searchData = {};
    _this.lastParams = {};
    _this.total = 0;
    return _this;
  }

  CostStatement.prototype.onDatetimeDefaultValueChange = function (arr) {
    this.getSearchDataDateTime(arr);
  };

  CostStatement.prototype.onSearchDataBusinessTypeChange = function (businessType) {
    if (businessType !== undefined) {
      this.queryCostType(businessType);
    } else {
      this.costTypeList = [];
    }
  };

  CostStatement.prototype.created = function () {
    var _this = this;

    this.columns = [{
      title: this.t('账户编码'),
      dataIndex: 'account_code',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('单号'),
      dataIndex: 'order_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('参考号'),
      dataIndex: 'reference_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: this.t('业务类型'),
      dataIndex: 'business_type_text',
      filterEmpty: true
    }, {
      title: this.t('费用类型'),
      dataIndex: 'types_of_fee_text'
    }, {
      title: this.t('流水类型'),
      dataIndex: 'flow_type_text',
      filterEmpty: true
    }, {
      title: this.t('账单状态'),
      dataIndex: 'charge_type_text',
      filterEmpty: true
    }, {
      title: this.t('金额'),
      align: 'right',
      scopedSlots: {
        customRender: 'amount'
      }
    }, {
      title: this.t('账户余额'),
      align: 'right',
      scopedSlots: {
        customRender: 'currency_balance_text'
      }
    }, {
      title: this.t('币种'),
      dataIndex: 'currency_code',
      filterEmpty: true
    }, {
      title: this.t('费用发生时间'),
      dataIndex: 'add_time',
      filterEmpty: true
    }];
    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys, selectedRows) {
        _this.rowSelection.selectedRowKeys = _this.selectedList = selectedRowKeys;
        var pendingConfirmList = [];
      }
    };
    this.searchData = this.getInitSearchData();
    this.getSearchDataDateTime(this.datetimeDefaultValue);
    this.queryCostStatementList();
    this.queryAccountList();
    this.queryCurrencyList();
  };

  CostStatement.prototype.queryCostStatementList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data, list, total, prev_search_after, next_search_after, cost_statement_list_es_point;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.lastParams = this.$util.deepCopy(this.searchData);
            return [4, this.$api.finance.queryCostStatementList(this.searchData)];

          case 1:
            data = _a.sent().data;
            list = data.list, total = data.total, prev_search_after = data.prev_search_after, next_search_after = data.next_search_after, cost_statement_list_es_point = data.cost_statement_list_es_point;
            this.searchData.prev_token = prev_search_after;
            this.searchData.next_token = next_search_after;
            this.esPoint = cost_statement_list_es_point;
            this.dataList = list;
            this.total = total;
            return [2];
        }
      });
    });
  };

  CostStatement.prototype.queryCurrencyList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryCurrencyList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.currencyList = data;
            return [2];
        }
      });
    });
  };

  CostStatement.prototype.queryAccountList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryAccountList()];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.accountList = data.map(function (item) {
              return __assign(__assign({}, item), {
                sign_business_list_text: item.sign_business_list.map(function (it) {
                  return it.key;
                }).join(',')
              });
            });
            return [2];
        }
      });
    });
  };

  CostStatement.prototype.queryCostType = function (businessType) {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b, data, code;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            return [4, this.$api.finance.queryCostType({
              sign_business_type: businessType
            })];

          case 1:
            _a = _c.sent(), _b = _a.data, data = _b === void 0 ? [] : _b, code = _a.code;
            this.costTypeList = data;
            return [2];
        }
      });
    });
  };

  CostStatement.prototype.getSearchDataDateTime = function (arr) {
    if (arr.length) {
      this.searchData.happen_start_time = this.$util.formatDateTime(arr[0]);
      this.searchData.happen_end_time = this.$util.formatDateTime(arr[1]);
    } else {
      this.searchData.happen_start_time = '';
      this.searchData.happen_end_time = '';
    }
  };

  CostStatement.prototype.getInitSearchData = function () {
    return {
      page_index: 1,
      page_size: 10,
      types_of_fee: undefined,
      flow_type: undefined,
      order_number: undefined,
      reference_number: undefined,
      account_code: undefined,
      happen_start_time: undefined,
      happen_end_time: undefined,
      business_type: undefined,
      currency_code: undefined,
      charge_type: undefined,
      number_list: [],
      next_token: '',
      prev_token: '',
      number_type: this.$enum.finance.CostStatementSearchEnum.ORDER_NUMBER
    };
  };

  CostStatement.prototype.handlePageChange = function (page) {
    if (page > this.searchData.page_index) {
      this.searchData.search_after_id = this.searchData.next_token;
      delete this.searchData.search_before_id;
    } else if (page < this.searchData.page_index) {
      this.searchData.search_before_id = this.searchData.prev_token;
      delete this.searchData.search_after_id;
    } else {
      delete this.searchData.search_after;
    }

    this.initPage();
    this.searchData.page_index = page;
    this.queryCostStatementList();
  };

  CostStatement.prototype.handleTabChange = function (key) {
    this.initPage();
    this.queryCostStatementList();
  };

  CostStatement.prototype.initPage = function () {
    this.searchData.page_index = 1;
    this.selectedList = [];
    this.selectedPendingConfirmList = [];
    this.rowSelection.selectedRowKeys = [];
  };

  CostStatement.prototype.handleSearch = function () {
    this.initPage();
    this.queryCostStatementList();
  };

  CostStatement.prototype.handleReset = function () {
    var _this = this;

    this.searchData = this.getInitSearchData();
    this.datetimeDefaultValue = this.$util.getDefaultTimeCondition(31);
    this.initPage();
    this.$nextTick(function () {
      return _this.queryCostStatementList();
    });
  };

  CostStatement.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, _a, code, data, message;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            postData = {};
            postData = __assign({}, this.lastParams);
            delete postData.page_index;
            delete postData.page_size;

            if (isAll) {
              postData["export"] = 1;
              postData.id_list = [];
            } else {
              if (!this.selectedList.length) {
                return [2, this.$message.warn(this.t('common', this.$config.exportSelectedEmptyTip))];
              }

              postData["export"] = 2;
              postData.id_list = this.selectedList;
            }

            return [4, this.$api.finance.exportCostStatement(postData)];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data, message = _a.message;

            if (code === 0) {
              this.$util.exportExcel(data);
            } else {
              this.$message.error(message);
            }

            return [2];
        }
      });
    });
  };

  __decorate([enumData('Finance/CostStatementSearchEnum')], CostStatement.prototype, "costStatementSearchEnum", void 0);

  __decorate([enumData('Finance/FlowTypeEnum')], CostStatement.prototype, "flowTypeList", void 0);

  __decorate([enumData('Finance/CostStatementBusinessTypeEnum')], CostStatement.prototype, "businessTypeList", void 0);

  __decorate([enumData('Finance/ChargeTypeEnum')], CostStatement.prototype, "chargeTypeList", void 0);

  __decorate([Watch('datetimeDefaultValue', {
    immediate: true
  })], CostStatement.prototype, "onDatetimeDefaultValueChange", null);

  __decorate([Watch('searchData.business_type')], CostStatement.prototype, "onSearchDataBusinessTypeChange", null);

  __decorate([loading('loadingStatus')], CostStatement.prototype, "queryCostStatementList", null);

  __decorate([userPrefPageSize('costStatementList')], CostStatement.prototype, "getInitSearchData", null);

  CostStatement = __decorate([Component], CostStatement);
  return CostStatement;
}(Vue);

export default CostStatement;